import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken() {
  return Cookies.get(TokenKey)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function getLoginId() {
  return Cookies.get('loginId')
}
export function setLoginId(loginId) {
  return Cookies.set('loginId', loginId)
}
export function removeLoginId() {
  return Cookies.remove('loginId')
}
export function getMaskStatus() {
  return Cookies.get('maskStatus')
}
export function setMaskStatus(maskStatus) {
  return Cookies.set('maskStatus', maskStatus)
}
export function removeMaskStatus() {
  return Cookies.remove('maskStatus')
}
export function setMerchantId(merchantId) {
  return localStorage.setItem('merchantId', merchantId)
}
export function getMerchantId() {
  return localStorage.getItem('merchantId')
}
export function setMerchantNumber(merchantNumber) {
  return localStorage.setItem('merchantNumber', merchantNumber)
}
export function getMerchantNumber() {
  return localStorage.getItem('merchantNumber')
}
export function setUserId(userId) {
  return localStorage.setItem('userId', userId)
}
export function getUserId() {
  return localStorage.getItem('userId')
}
export function setLastLoginTime(lastLoginTime) {
  return localStorage.setItem('lastLoginTime', lastLoginTime)
}
export function getLastLoginTime() {
  return localStorage.getItem('lastLoginTime')
}
export function setPermissions(permissions) {
  return localStorage.setItem('permissions', permissions)
}
export function getPermissions() {
  return JSON.parse(localStorage.getItem('permissions'))
}
export function removePermissions() {
  return localStorage.removeItem('permissions')
}
export function setRoutes(showRoutes) {
  return localStorage.setItem('showRoutes', JSON.stringify(showRoutes))
}
export function getRoutes() {
  return JSON.parse(localStorage.getItem('showRoutes'))
}
export function setMerchantBasic(merchantBasic) {
  return localStorage.setItem('merchantBasic', JSON.stringify(merchantBasic))
}
export function getMerchantBasic() {
  return JSON.parse(localStorage.getItem('merchantBasic'))
}
export function getLanguage() {
  return localStorage.getItem('language')
}
export function setLanguage(value) {
  return localStorage.setItem('language', value)
}
export function getFlag() {
  return Cookies.get('flag')
}
export function setFlag(flag) {
  return Cookies.set('flag', flag)
}